import React from 'react';
import { Modal, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SecurityIcon from '@mui/icons-material/Security'
import OTPInput from './Otp';

interface OtpModalProps {
  open: boolean;
  onClose: () => void;
  onOtpSubmit: (otp: string) => void;
  onResendOtp: () => void;
  numberOfColunms?: number;
  mobileNumber?: string;
  isLoading?: boolean;
  isResending?: boolean;
}

const OtpModal: React.FC<OtpModalProps> = ({ open, isLoading, isResending, numberOfColunms = 4, mobileNumber, onClose, onOtpSubmit, onResendOtp }) => {
  return (
    <Modal
      open={open}
      onClose={!isLoading ? onClose : undefined}
      aria-labelledby="otp-modal-title"
      aria-describedby="otp-modal-description"
      style={styles.modalContainer}
    >
      <div style={styles.modalContent}>
        {!isLoading && (
          <IconButton
            onClick={onClose}
            style={styles.closeButtonIcon}
            aria-label="close"
            disabled={isLoading}
          >
            <CloseIcon />
          </IconButton>
        )}

        <div style={styles.header}>
          <div style={styles.iconContainer}>
            <SecurityIcon style={styles.securityIcon} />
          </div>
          <h4 id="otp-modal-title" style={styles.modalTitle}>Verification Required</h4>
          {mobileNumber ? <small style={styles.subtitle}>Enter the OTP sent to {mobileNumber}</small>
            : <small style={styles.subtitle}>Enter the OTP sent to Whatsapp</small>}
        </div>

        <Divider style={styles.divider} />

        <OTPInput
          numberOfColunms={numberOfColunms}
          onSubmit={onOtpSubmit}
          onResend={onResendOtp}
          isLoading={isLoading}
          isResending={isResending}
        />
      </div>
    </Modal>
  );
};

// Styles for the modal and content
const styles: { [key: string]: React.CSSProperties } = {
  modalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    
    textAlign: 'center',
    position: 'relative',
  },
  modalTitle: {
    marginBottom: '30px',
    fontSize: '1.15rem',
    fontWeight: '500',
    color: '#333',
  },
  buttonContainer: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
  },
  closeButton: {
    backgroundColor: '#f44336',
    color: '#fff',
    textTransform: 'none',
    padding: '10px 20px',
    borderRadius: '6px',
    boxShadow: 'none',
    transition: 'background-color 0.3s ease',
  },
  closeButtonIcon: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    color: '#f44336',
  },
};

export default OtpModal;
